export default {
    async beforeRouteEnter(to, from, next) {
        next(async (vm) => {
            if(to.name === "on-boarding" &&
             vm.$store.state?.auth?.currentUser.account_types.length
            ) next(to)
            else {
                if (
                    vm.$store.state?.auth?.isAuthenticated &&
                    !vm.$store.state?.auth?.currentUser.account_types.length
                    ) next({name: 'on-boarding'})
                else next()
            }
        })
    }
}
